// Central site configuration for Culture Diamond Jewels Pvt. Ltd.
// Brand, navigation, contact, collections, leadership and trade information.

export const brand = {
  name: "Culture Diamond Jewels",
  legalName: "Culture Diamond Jewels Pvt. Ltd.",
  tagline: "Diamonds As Unique As You",
  // Gold wordmark reads cleanly on the dark charcoal navbar/footer.
  logo: "/assets/logo/culture-diamond-gold.png",
  logoWhite: "/assets/logo/culture-diamond-white.png",
  logoBlack: "/assets/logo/culture-diamond-black.png",
};

export const nav = [
  { label: "The Legacy", to: "/about" },
  { label: "Collections", to: "/collections" },
  { label: "Diamond Guide", to: "/diamonds" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const social = {
  // Only the official Culture Diamond Instagram account is shown site-wide.
  // NOTE: confirm the exact handle/URL with the client.
  instagram: "https://www.instagram.com/culturediamondjewels/",
  instagramHandle: "@culturediamondjewels",
};

export const contact = {
  phone: "+91 98987 47788",
  email: "culturediamondjewels@gmail.com",
  addressLines: [
    "Culture Diamond Jewels Pvt. Ltd.",
    "405, Ten-11, Near Maradia Plaza,",
    "C.G. Road, Ahmedabad – 380006",
  ],
  hours: "Mon – Sat · 11:00 AM – 8:00 PM",
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=Ten-11+Maradia+Plaza+C.G.+Road+Ahmedabad",
};

export const showroom = {
  image: "/assets/about/showroom-dusk.jpg",
  heading: "Visit our showroom",
  text:
    "Find us at Ten-11 on C.G. Road, in the heart of Ahmedabad. Step into an intimate setting where every diamond and CZ creation can be seen, tried and tailored, with our consultants on hand to guide you.",
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=Ten-11+Maradia+Plaza+C.G.+Road+Ahmedabad",
};

// Leadership shown in the Legacy / Directors section.
// NOTE: the supplied photo features Bhadreshbhai (left) and Kevinbhai (right);
// a portrait of Chandrakantbhai was not provided.
export const directors = [
  {
    name: "Kevinbhai Patel",
    role: "Director",
    image: "/assets/about/directors.jpg",
    focus: "right",
  },
  {
    name: "Bhadreshbhai Patel",
    role: "Director",
    image: "/assets/about/directors.jpg",
    focus: "left",
  },
  {
    name: "Chandrakantbhai Patel",
    role: "Director",
    image: "",
    focus: "center",
  },
];

export const collections = [
  {
    id: "lab-grown",
    name: "Lab-Grown Diamonds",
    blurb:
      "Ethically created diamonds with the same fire, brilliance and hardness as mined stones — certified and conscientiously priced.",
    image: "/assets/cd/prod-ring-box.jpg",
  },
  {
    id: "diamond",
    name: "Diamond Jewellery",
    blurb:
      "Natural diamond necklaces, rings, earrings and mangalsutras, each stone independently graded for uncompromised sparkle.",
    image: "/assets/cd/prod-neck-pear.jpg",
  },
  {
    id: "premium-cz",
    name: "Premium CZ Jewellery",
    blurb:
      "Meticulously set premium cubic zirconia in fine metal — the look of luxury, crafted for everyday brilliance.",
    image: "/assets/cd/prod-earrings.jpg",
  },
];

export const features = [
  {
    title: "Certified Diamonds",
    text: "Every diamond is independently graded and certified by GIA, IGI or SGI for guaranteed quality and provenance.",
  },
  {
    title: "Global Import & Export",
    text: "Two years of importing and exporting diamonds and CZ jewellery to the UK, US, Australia and Dubai.",
  },
  {
    title: "Diamonds As Unique As You",
    text: "From lab-grown and natural diamonds to premium CZ, every piece is selected and finished to your taste.",
  },
  {
    title: "Fine Craftsmanship",
    text: "Hand-finished settings that showcase each stone's cut, colour and clarity at its brilliant best.",
  },
];

// Import & Export trade information.
export const trade = {
  years: 2,
  heading: "Import & Export",
  text:
    "For the past two years, Culture Diamond Jewels has been actively engaged in the import and export of diamonds and premium CZ jewellery, serving discerning clients and partners across the world.",
  markets: [
    { name: "United Kingdom", code: "UK" },
    { name: "United States", code: "US" },
    { name: "Australia", code: "AU" },
    { name: "Dubai (UAE)", code: "AE" },
  ],
};

// Diamond certification bodies referenced across the site.
export const certifications = [
  { code: "GIA", name: "Gemological Institute of America" },
  { code: "IGI", name: "International Gemological Institute" },
  { code: "SGI", name: "Solitaire Gemological Institute" },
];
